module.exports = __webpack_public_path__ + "img/1.ec3658b2.png";